import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=690c01e5&scoped=true&"
import script from "./Contact.js?vue&type=script&lang=js&"
export * from "./Contact.js?vue&type=script&lang=js&"
import style0 from "./Contact.scss?vue&type=style&index=0&id=690c01e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690c01e5",
  null
  
)

export default component.exports